import { getConnectorCatalog } from "@/components/connectors/api.ts";
import { useConnectorOAuthResults } from "@/components/connectors/useConnectorOAuthResults.ts";
import { useQuery } from "@tanstack/react-query";

/**
 * The connector catalog, kept fresh through both ways a connect can finish.
 *
 * The query and the OAuth-result subscription travel together deliberately.
 * Reading the catalog is half of what a surface with a Connect button needs: a
 * typed credential resolves in this tab and invalidates the key directly, but
 * OAuth leaves for the provider in a tab of its own and reports back over a
 * BroadcastChannel that only reaches a subscriber. Every surface needs both, and
 * the in-thread picker card — which had the query and not the subscription —
 * sat stale through every OAuth connect while Settings refreshed fine
 * (BIG-7231). Bundled here, a new surface cannot pick up one half.
 *
 * `showToasts: false` for a surface that can be on screen more than once, so
 * several connector cards in one thread don't each announce the same
 * connection; they show it in place by flipping the row to "Connected".
 */
export function useConnectorCatalog({ showToasts = true }: { showToasts?: boolean } = {}) {
  useConnectorOAuthResults({ showToasts });
  return useQuery({
    queryKey: ["connectorCatalog"],
    queryFn: getConnectorCatalog,
  });
}
